<template>

</template>

<script>
  export default {
    name: "Dashboard",
    created() {
      console.log(
        this.$store.state.counter
      );
    }
  }
</script>

<style scoped>

</style>
